/**
 * Shared logger – no-op when disabled, prefixed console when enabled.
 * @package AdvancedTrackingManager
 */

export interface Logger {
  debug: (message: string, data?: unknown) => void;
  warn: (message: string, data?: unknown) => void;
  error: (message: string, data?: unknown) => void;
}

const noop = (_msg: string, _data?: unknown): void => {};

/**
 * Create a logger with optional prefix. When enabled is false, methods are no-ops.
 */
export const createLogger = (prefix: string, enabled: boolean): Logger => {
  if (!enabled) {
    return { debug: noop, warn: noop, error: noop };
  }
  return {
    debug: (message: string, data?: unknown) => {
      if (data !== undefined) {
        console.log(`[${prefix}]`, message, data);
      } else {
        console.log(`[${prefix}]`, message);
      }
    },
    warn: (message: string, data?: unknown) => {
      if (data !== undefined) {
        console.warn(`[${prefix}]`, message, data);
      } else {
        console.warn(`[${prefix}]`, message);
      }
    },
    error: (message: string, data?: unknown) => {
      if (data !== undefined) {
        console.error(`[${prefix}]`, message, data);
      } else {
        console.error(`[${prefix}]`, message);
      }
    },
  };
};
